<div class="hot-table sku-config-table hot-custom-check-box input-config-table">
  <hot-table [hotId]="hotTableId"></hot-table>
</div>

